/* @flow */
import ValuePropsRow from './ValuePropsRow';

export default ValuePropsRow;
